import * as React from 'react';

import * as videoReviewsSimple from './videoReviewsSimple.module.scss';

export const VideoReviewsSimple = ({ data, sectionClassName, titleClassName }) => {
  return (
    <section className={sectionClassName || videoReviewsSimple.videoReviewsSimple}>
      <div className="container">
        <h3 className={titleClassName || videoReviewsSimple.videoReviewsSimple__title}>Отзывы учеников</h3>
        <div className={videoReviewsSimple.videoReviewsSimple__list}>
          {data.map((elem, index) => (
            <div className={videoReviewsSimple.videoReviewsSimple__item} key={index}>
              <div className={videoReviewsSimple.videoReviewsSimple__videoWrap}>
                <iframe
                  key={elem}
                  className={videoReviewsSimple.videoReviewsSimple__video}
                  src={elem.src}
                  title={elem.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
              <p className={videoReviewsSimple.videoReviewsSimple__descr} key={elem}>
                {elem.description}
              </p>
              { elem.quote && <p className={videoReviewsSimple.videoReviewsSimple__quote}><i>{elem.quote}</i></p> }
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
